import { useRef, useState, useEffect } from "react";
import { X, Volume2, VolumeX } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function IntroVideo({ onClose }) {
  const videoRef = useRef(null);
  const { t } = useLang();
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const v = videoRef.current;
    if (v) {
      v.muted = true;
      v.play().catch(() => {});
    }
  }, []);

  const toggleSound = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4 animate-fade-in"
      data-testid="welcome-video-overlay"
    >
      <div className="relative w-full max-w-lg rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-black/70 bg-black">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-20 flex items-center gap-1.5 bg-black/60 hover:bg-black/80 text-white text-sm font-semibold px-4 py-2 rounded-full border border-white/15 transition-colors"
          data-testid="welcome-skip-btn"
        >
          {t("welcome.skip")} <X size={16} />
        </button>

        <button
          onClick={toggleSound}
          className="absolute bottom-3 left-3 z-20 flex items-center gap-2 adj-gradient text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg hover:opacity-90 transition-opacity"
          data-testid="welcome-sound-btn"
        >
          {muted ? <Volume2 size={16} /> : <VolumeX size={16} />}
          {muted ? t("welcome.sound") : t("welcome.mute")}
        </button>

        <video
          ref={videoRef}
          src="/promo.mp4"
          poster="/promo-poster.jpg"
          autoPlay
          muted
          playsInline
          controls
          preload="metadata"
          onEnded={onClose}
          className="w-full aspect-square object-contain bg-black"
          data-testid="welcome-video"
        />
      </div>
    </div>
  );
}
